import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import './CursosCompras.css';


const CursosCompras = () => {
  const [cursos, setCursos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cargarCursos();
  }, []);

  const agregarAlCarrito = (curso) => {
    const carrito = JSON.parse(localStorage.getItem('carrito') || '[]');
    const existe = carrito.find(item => item.id === curso.id);
    
    if (existe) {
      existe.cantidad = (existe.cantidad || 1) + 1;
    } else {
      carrito.push({ id: curso.id, nombre: curso.nombre, precio: curso.precio, cantidad: 1 });
    }
    
    localStorage.setItem('carrito', JSON.stringify(carrito));
    
    const notificacion = document.createElement('div');
    notificacion.textContent = `✅ "${curso.nombre}" agregado al carrito`;
    notificacion.style.cssText = `
      position: fixed; 
      top: 70px;
      right: 20px; 
      background: #001b7a; 
      color: white; 
      padding: 12px 24px; 
      border-radius: 8px; 
      z-index: 200000;
      box-shadow: 0 4px 12px rgba(0,0,0,0.2);
      animation: fadeOut 3s ease;
    `;
    document.body.appendChild(notificacion);
    setTimeout(() => notificacion.remove(), 3000);
    
    window.location.href = '/forma-pagos';
  };

  const cargarCursos = async () => {
    const { data: cursos, error } = await supabase
      .from('igcescuelacursos')
      .select('*')
      .eq('activo', true)
      .order('id');
    
    if (error) {
      console.error('Error:', error);
      setCursos([]);
    } else if (!cursos || cursos.length === 0) {
      setCursos([]);
    } else {
      setCursos(cursos);
    }
    setLoading(false);
  };

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '50px' }}>Cargando cursos...</div>;
  }

  if (cursos.length === 0) {
    return <div style={{ textAlign: 'center', padding: '50px' }}>📭 No hay cursos disponibles</div>;
  }

  return (
    <div className="container-cursos">
      {cursos.map(curso => (
        <div key={curso.id} className="card-cursos">
          <img 
            src={curso.imagen_url || './img/IMG - TEMP.png'} 
            className="img-curso" 
            alt={curso.nombre} 
          />
          <div className="info-curso">
            <h4>{curso.nombre}</h4>
            <p>{curso.descripcion || 'Descripción del curso'}</p>
            <span className="precio">Precio S/{curso.precio}</span>
            <button 
              className="btn-comprar"
              onClick={() => agregarAlCarrito(curso)}
            >
              Agregar al carrito
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CursosCompras;